module.exports = __webpack_public_path__ + "img/流体力学1_6.31abb124.jpg";